import $ from 'jquery';

import widgetFactory from '../../../widgetFactory';
import textInputValidate from '../../textInputValidate';

import checkValidPhoneNumber from '../../../../Services/Shop/checkValidPhoneNumber';
import PhoneNumberCheckInvalidArgumentsException from '../../../../Services/Shop/PhoneNumberCheckInvalidArgumentsException';
import InvalidPhoneNumberException from '../../../../Services/Shop/InvalidPhoneNumberException';

const widgetName = 'phoneInput';

export default widgetFactory(widgetName, textInputValidate, {
  options: {
    countryElement: null,
    async: true,
    submit: '.js-subscription-submit',
  },

  _create() {
    this._super(widgetName);
    this._phoneNumberValided = false;
    this.elements.$countrySelector = $(this.options.countryElement);
    this.elements.$submitButton = this.element
      .parentsUntil('#payform', '.js-zipCodeSelector')
      .parent()
      .find(this.options.submit);
    this.elements.$form = this.element.parent('#payform');

    this.elements.$countrySelector.on('change', () => {
      this.validate(this._getPhoneNumber());
    });

    this.element.on('change', () => {
      this.elements.$submitButton.prop('disabled', false);
      this._phoneNumberValided = true;
    });

    this.element.on('keypress', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });

    this.elements.$submitButton.on('click', async () => {
      await this.validate(this._getPhoneNumber());

      if (!this._phoneNumberValided) {
        return false;
      }
    });
  },

  /**
   *
   * @returns {string}
   * @private
   */
  _getPhoneNumber() {
    return this.element.val();
  },

  /**
   *
   * @returns {string}
   * @private
   */
  _getCountryCode() {
    return this.elements.$countrySelector.val();
  },

  /**
   * @param value
   * @returns {promise}
   * @private
   */
  _validator(value) {
    const contryCode = this._getCountryCode();
    return checkValidPhoneNumber(value, contryCode)
      .then(() => {
        this._phoneNumberValided = true;
      })
      .catch((e) => {
        this.elements.$submitButton.prop('disabled', true);
        this._phoneNumberValided = false;
        throw InvalidPhoneNumberException({ reason: e.reason });
      })
      .catch({ type: PhoneNumberCheckInvalidArgumentsException.type }, (e) => {});
  },
});
